export default __webpack_public_path__ + "static/media/Ocelots_Still_3.e5e6ec8d.jpg";